import {
  API_GET_ORG,
  API_GETME,
  API_LOGIN,
  API_TOKEN,
  AUTH_BEARER,
  AUTH_SESSION,
} from "../constants";
import {
  axiosDelete,
  axiosGet,
  axiosPost,
  getAuthorization,
} from "../utils/axios";

const LoginApi = {
  login: async (orgName: string, email: string, password: string) => {
    return await axiosPost(
      API_LOGIN,
      { orgName: orgName, email: email, password: password },
      {
        withCredentials: true, // 允許攜帶和保存 Cookie
      }
    )
      .then((res: any) => res)
      .catch((error: any) => {
        console.error("Login Error:", error.response?.data || error.message);
        throw error;
      });
  },

  logout: async () => {
    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosDelete(API_LOGIN, headers)
      .then((res: any) => res.data)
      .catch((error: any) => {
        console.error("Logout Error:", error.response?.data || error.message);
        throw error;
      });
  },

  checkStatus: async () => {
    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(API_LOGIN, {}, headers)
      .then((res: any) => res.data)
      .catch((error: any) => {
        console.error("checkStatus Error:", error.response?.data || error.message);
        throw error;
      });
  },

  getMe: async () => {
    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(API_GETME, {}, headers)
      .then((res: any) => res.data.data)
      .catch((error: any) => {
        console.error("GetMe Error:", error.response?.data || error.message);
        return undefined;
      });
  },

  getOrg: async () => {
    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(API_GET_ORG, {}, headers)
      .then((res: any) => res.data.data)
      .catch((error: any) => {
        console.error("Get ORG Error:", error.response?.data || error.message);
        return undefined;
      });
  },

  getToken: async (orgName: string, email: string, password: string) => {
    return await axiosPost(API_TOKEN, {
      grant_type: "password",
      client_id: "nYrnfYEv",
      orgName: orgName,
      email: email,
      password: password,
    })
      .then((res: any) => res.data)
      .catch((error: any) => {
        console.error("getToken Error:", error.response?.data || error.message);
        return undefined;
      });
  },
};

export default LoginApi;
